<app-spinner *ngIf="loadingLocations"></app-spinner>

<div *ngIf="locations && meta.totalItems > 0">
  <form name="form" novalidate>
    <div class="form-group">
      <div class="row">
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-addon">
              <i class="fa fa-search" title="{{ 'NAME' | translate }}"></i>
            </span>
            <app-search-text-input
              [field]="'by_name'"
              [value]="filterCriteria.by_name"
              [pattern]="'text'"
              [placeHolder]="'NAME'"
              (searched)="onSearched($event)"
            >
            </app-search-text-input>
          </div>
        </div>
        <div class="col-md-3">
          <div class="input-group">
            <span class="input-group-addon">
              <i class="fa fa-search" title="{{ 'PARENT_LOCATION' | translate }}"></i>
            </span>
            <app-search-text-input
              [field]="'by_parentLocation'"
              [value]="filterCriteria.by_parentLocation"
              [pattern]="'text'"
              [placeHolder]="'PARENT_LOCATION'"
              (searched)="onSearched($event)"
            >
            </app-search-text-input>
          </div>
        </div>

        <div class="col-md-3">
          <div class="input-group">
            <span class="input-group-addon">
              <i class="fa fa-map-marker" title="{{ 'COUNTRY' | translate }}"></i>
            </span>
            <app-search-text-input
              [field]="'by_country'"
              [value]="filterCriteria.by_country"
              [pattern]="'text'"
              [placeHolder]="'COUNTRY'"
              (searched)="onSearched($event)"
            >
            </app-search-text-input>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div *ngIf="meta.itemsFound > 0">
    <table class="table table-striped table-hover table-highlight-head table-vertical-align">
      <thead>
        <tr>
          <th>
            <app-sort-by
              [sortDir]="filterCriteria.sortDir"
              [sortBy]="filterCriteria.sortedBy"
              [sortValue]="'name'"
              (sorted)="onSorted($event)"
            >
              {{ 'NAME' | translate }}
            </app-sort-by>
          </th>
          <th>
            <app-sort-by
              [sortDir]="filterCriteria.sortDir"
              [sortBy]="filterCriteria.sortedBy"
              [sortValue]="'parentLocation'"
              (sorted)="onSorted($event)"
            >
              {{ 'PARENT_LOCATION' | translate }}
            </app-sort-by>
          </th>
          <th>
            <app-sort-by
              [sortDir]="filterCriteria.sortDir"
              [sortBy]="filterCriteria.sortedBy"
              [sortValue]="'country'"
              (sorted)="onSorted($event)"
            >
              {{ 'COUNTRY' | translate }}
            </app-sort-by>
          </th>
          <th style="width: 60px" class="align-center">
            <a
              (click)="reloadLocations()"
              title="{{ 'REFRESH' | translate }}"
              class="btn btn-xs btn-transparent"
            >
              <i class="fa fa-refresh"></i>
            </a>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let location of locations" id="{{ location.id }}">
          <!-- Name -->
          <td
            (click)="selectLocation(location)"
            [ngClass]="utilService.checkItemStatus(location.status)"
            class="cursor"
          >
            {{ location.name }}
          </td>

          <!-- Parent location -->
          <td
            (click)="selectLocation(location)"
            [ngClass]="utilService.checkItemStatus(location.status)"
            class="cursor"
          >
            {{
              location.parentLocation
                ? location.parentLocation.name
                : '&lt; ' + ('SUPERIOR_LOCATION' | translate) + ' &gt;'
            }}
          </td>

          <!-- Country -->
          <td
            (click)="selectLocation(location)"
            [ngClass]="utilService.checkItemStatus(location.status)"
            class="cursor"
          >
            {{ location.country.name }}
          </td>

          <td class="align-center">
            <div class="btn-group">
              <span class="dropdown-toggle btn btn-xs btn-transparent" data-toggle="dropdown">
                <i class="fa fa-ellipsis-h fa-lg"></i>
              </span>
              <ul class="dropdown-menu pull-right">
                <li *ngIf="permissions.canShow">
                  <a class="cursor" (click)="selectLocation(location, 'edit')">
                    <i class="fa fa-pencil"></i> {{ 'EDIT' | translate }}
                  </a>
                </li>
                <li *ngIf="permissions.canUpdate">
                  <a class="cursor" (click)="changeLocationStatus(location)">
                    <i
                      [ngClass]="
                        location.status === 'active' ? 'fa fa-minus-square' : 'fa fa-check-square'
                      "
                    ></i>
                    {{
                      location.status === 'active'
                        ? ('DEACTIVATE' | translate)
                        : ('ACTIVATE' | translate)
                    }}
                  </a>
                </li>
                <li *ngIf="permissions.canDestroy" class="divider"></li>
                <li *ngIf="permissions.canDestroy">
                  <a class="cursor" (click)="deleteLocation(location)">
                    <i class="fa fa-trash"></i> {{ 'DELETE' | translate }}</a
                  >
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <app-table-footer
      [meta]="meta"
      (selectedPage)="onSelectedPage($event)"
      *ngIf="meta.totalPages > 1"
    ></app-table-footer>
  </div>

  <div *ngIf="meta.itemsFound === 0" class="alert alert-warning align-center" style="padding: 40px">
    <i class="fa fa-ban fa-4x"></i>
    <h3>{{ 'NO_ITEMS_FOUND' | translate }}</h3>

    <a (click)="clearSearchForm()" class="cursor">
      <i class="fa fa-times"></i> {{ 'CLEAR_SEARCH' | translate }}
    </a>
  </div>
</div>

<div
  *ngIf="locations && meta.totalItems === 0"
  class="alert alert-info align-center"
  style="padding: 40px"
>
  <i class="fa fa-ban fa-4x"></i>
  <h5>{{ 'NO_ITEMS_FOUND' | translate }}</h5>
</div>
